import { useState, useEffect } from 'react'
import styles from '@/components/directory/v2/card-view/EVsCardsComponent.module.css'
import EVsCardItemComponent from '@/components/directory/v2/card-view/EVsCardItemComponent'
import EVsCardItemVariantsManager from '@/components/directory/v2/card-view/EVsCardItemVariantsManager'

const EVsCardsComponent = ({ result }) => {
  const { make, model_count, models } = result

  const [selectedModelIndex, setSelectedModelIndex] = useState(null)
  const [variants, setVariants] = useState([])
  const [columns, setColumns] = useState(4) // Default number of columns

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth
      if (width <= 480) {
        setColumns(1)
      } else if (width <= 768) {
        setColumns(1)
      } else {
        setColumns(4)
      }
    }

    updateColumns() // Initial check
    window.addEventListener('resize', updateColumns)
    return () => window.removeEventListener('resize', updateColumns)
  }, [])

  const handleModelClick = async (model, index) => {
    if (selectedModelIndex === index) {
      setSelectedModelIndex(null)
      setVariants([])
      return
    }

    setSelectedModelIndex(index)

    const initialVariants = Array.from({ length: model.variant_count }, (_, index) => ({
      id: index + 1,
      loading: true,
      data: null,
    }))
    setVariants(initialVariants)

    const encodedMake = encodeURIComponent(model.make)
    const encodedModel = encodeURIComponent(model.model)

    const apiUrl = `${process.env.NEXT_PUBLIC_CLEARWATT_BASE_API}/vehicles/public_list/?&make__name=${encodedMake}&model=${encodedModel}&page_size=100`

    try {
      const response = await fetch(apiUrl)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()
      setVariants(
        initialVariants.map((variant, index) => ({
          ...variant,
          loading: false,
          data: data.results[index] || null,
        })),
      )
    } catch (error) {
      console.error('There has been a problem with your fetch operation:', error)
      setVariants(initialVariants.map((variant) => ({ ...variant, loading: false }))) // stop loading state on error
    }
  }

  const renderModels = () => {
    const items = []
    let currentRow = []

    models.forEach((model, index) => {
      currentRow.push(
        <div key={`model-${index}`} className={styles.evsCardItem}>
          <EVsCardItemComponent
            evModel={model}
            onClick={() => handleModelClick(model, index)}
            isSelected={selectedModelIndex === index}
          />
        </div>,
      )

      // Check if the current row is full or if it is the last model
      if (currentRow.length === columns || index === models.length - 1) {
        items.push(
          <div key={`row-${index}`} className={styles.evsRow}>
            {currentRow}
          </div>,
        )

        // Insert the variants row if the selected model is in the current row
        if (selectedModelIndex !== null && Math.floor(selectedModelIndex / columns) === Math.floor(index / columns)) {
          items.push(
            <div key={`variant-${index}`} className={styles.variantsManagerRow}>
              <div className={styles.variantsManager}>
                <EVsCardItemVariantsManager variants={variants} />
              </div>
            </div>,
          )
        }

        // Reset currentRow
        currentRow = []
      }
    })

    return items
  }

  return (
    <div id={`category-${make}`} className={styles.container}>
      <div className={styles.title}>
        <span className={styles.make}>{make}</span>
        <span className={styles.count}>{model_count}</span>
      </div>
      <div className={styles.evsList}>{renderModels()}</div>
    </div>
  )
}

export default EVsCardsComponent
